import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getCompany } from "../api/apiList";
import { getRequest } from "../api/apiServices";

interface TwitterKeys {
  appKey: string;
  appSecret: string;
  accessToken: string;
  accessSecret: string;
}

interface CompanyProfileState {
  id: number;
  name: string;
  logo: string;
  primaryColor: string;
  webUrl: string;
  companyVisionAndMission: string;
  employees: string;
  industry: string;
  services: string;
  employerValueProposition: string;
  companyMileStones: string;
  companyCulture: string;
  secondaryBenefits: string;
  linkedInKey: string;
  facebookKey: string;
  instagramKey: string;
  googleKey: string;
  youtubeKey: string | null;
  twitter: TwitterKeys;
  active: boolean;
  status: number;
  city: string;
  state: string;
  country: string;
  zipCode: string;
  assistantId: string;
  threadId: string;
}

export const fetchCompanyProfile = createAsyncThunk(
  "companyProfile/fetch",
  async (companyId: string, { rejectWithValue }) => {
    try {
      const response = await getRequest(getCompany(companyId)); // Pass userId here
      return response?.data?.data as CompanyProfileState;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const companyProfileSlice = createSlice({
  name: "companyProfile",
  initialState: null as CompanyProfileState | null,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchCompanyProfile.fulfilled,
      (_, action: PayloadAction<CompanyProfileState>) => {
        return action.payload; // ✅ No need to spread, directly return the new object
      }
    );
  },
});

export default companyProfileSlice.reducer;
